var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1127",
    "data-name": "Group 1127",
    transform: "translate(-1619 -175)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_490",
    "data-name": "Ellipse 490",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(1619 175)",
    fill: "#ff5e4f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "logout",
    transform: "translate(1632 185.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11095",
    "data-name": "Path 11095",
    d: "M2.271.057A2.728,2.728,0,0,0,.995.672,2.918,2.918,0,0,0,.1,2.025L0,2.342V15.666l.1.316A2.887,2.887,0,0,0,2,17.888l.316.1h8.016l.316-.1a2.887,2.887,0,0,0,1.906-1.905,3.73,3.73,0,0,0,.1-1.371c0-1.051,0-1.055-.084-1.188a.927.927,0,0,0-.225-.229.534.534,0,0,0-.376-.095.534.534,0,0,0-.376.095.927.927,0,0,0-.225.229c-.081.13-.084.162-.105,1.1a3.225,3.225,0,0,1-.1,1.171,1.414,1.414,0,0,1-.861.823,27.63,27.63,0,0,1-3.994.063H2.5l-.2-.081a1.429,1.429,0,0,1-.823-.865c-.06-.169-.063-.513-.063-6.63s0-6.462.063-6.63a1.429,1.429,0,0,1,.823-.865l.2-.081H6.311a27.643,27.643,0,0,1,3.994.063,1.415,1.415,0,0,1,.861.823,3.238,3.238,0,0,1,.1,1.174l.021.97.095.141a.718.718,0,0,0,1.181,0l.095-.144V3.4a3.743,3.743,0,0,0-.1-1.375A2.887,2.887,0,0,0,10.652.12l-.316-.1L6.416.014C3.168.011,2.457.018,2.271.057Z",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11096",
    "data-name": "Path 11096",
    d: "M15.117,6.083a.7.7,0,0,0-.4.8c.032.162.081.218.672.812l.636.643-4.342.007-4.342.011L7.2,8.449a.628.628,0,0,0-.309.594.547.547,0,0,0,.095.373.925.925,0,0,0,.229.225l.134.084,4.338.011,4.342.007-.636.643c-.591.594-.64.65-.672.812a.7.7,0,0,0,.96.8,9.911,9.911,0,0,0,1.076-1.009c.868-.879.942-.963,1.055-1.209a1.248,1.248,0,0,0,.12-.738,1.248,1.248,0,0,0-.12-.738c-.112-.246-.186-.33-1.055-1.209A9.9,9.9,0,0,0,15.68,6.083.657.657,0,0,0,15.117,6.083Z",
    fill: "#1a1a1a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignoutIcon);
export default __webpack_public_path__ + "static/media/signout-icon.68acb673bc6a19526a5875c5ee2a82fb.svg";
export { ForwardRef as ReactComponent };